import React, { Component } from 'react';
import { Grid, Label, Divider, Button } from 'semantic-ui-react'
import Select from 'react-select';
import * as moment from 'moment';
import axios from 'axios'
import { base, serverIp } from '../../../../config/constants';
import * as FbUtils from '../../../../Utilities/FireBaseUtils'
import * as Utils from '../../../../Utilities/Utils'
import Status from '../../../../config/OrderStatusConstants.js'


class SetUserDetails extends Component {
    constructor(props) {
        super(props);
        this.state = {
            orderType: '',
            orderTypeChoices: [],
        }
    }

    componentDidMount() {
        //SHIRT COLORS

    }

    setMale = () => {
        console.log("+++++++++ setMale");
        this.setGender("male");
    }

    setFemale = () => {
        console.log("+++++++++ setFemale");
        this.setGender("female");
    }

    setGender = (gender) => {
        console.log("+++++++++ setFemale");
        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {
            gender: gender,
            genderDateNum: d.getTime(),
            genderRequestedTime: now
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);

        axios.post(serverIp + 'userdetails/setUserDetails', {
            apiKey: "PrintB@da7",
            fbOrderKey: this.props.order.key,
            gender: gender
        })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
    }


    set18_25 = () => {
        console.log("+++++++++ set18_25");
        this.setAgeGroup("18_25");
    }

    set25_35 = () => {
        console.log("+++++++++ set25_35");
        this.setAgeGroup("25_35");
    }

    setAgeGroup = (ageGroup) => {
        console.log("+++++++++ setAgeGroup");
        var d = new Date();
        let now = moment().format('MMMM Do, h:mm:ss a');

        let orderUpdates = {
            ageGroup: ageGroup,
            ageGroupDateNum: d.getTime(),
            ageGroupRequestedTime: now
        }

        FbUtils.updateOrder(this.props.order.key, orderUpdates);

        axios.post(serverIp + 'userdetails/setUserDetails', {
            apiKey: "PrintB@da7",
            fbOrderKey: this.props.order.key,
            ageGroup: ageGroup
        })
            .then(function (response) {
                console.log(response);
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    render() {

        const maleButton = this.props.order.gender && this.props.order.gender != 'none'
            ? this.props.order.gender
            : <Button onClick={this.setMale}> MALE </Button>

        const femaleButton = this.props.order.gender  && this.props.order.gender != 'none'
            ? this.props.order.gender
            : <Button onClick={this.setFemale}> FEMALE </Button>

        const set18_25 = this.props.order.ageGroup
            ? this.props.order.ageGroup
            : <Button onClick={this.set18_25}> 18-25 </Button>

        const set25_35 = this.props.order.ageGroup
            ? this.props.order.ageGroup
            : <Button onClick={this.set25_35}> 25-35 </Button>

        const wholeUi = this.props.user.email == "ivanmworozi@gmail.com"
            ? <div>
                <Divider horizontal>{'GENDER!'}</Divider>
                {maleButton}::{femaleButton}
                <br/>
                {set18_25}::{set25_35}
            </div>
            : ''


        return (
            <div>
                {wholeUi}
            </div>
        )
    }
}

export default SetUserDetails;


// WEBPACK FOOTER //
// ./src/components/dashBoard/newDashboard/UserDetails/SetUserDetails.js